var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newFolderForTree(data) {
    var instance = {
        __type: "FolderForTree:#DecisionsFramework.ServiceLayer.Services.Folder",
        FolderID: null,
        FolderName: null,
        Alias: null,
        FolderBehaviorType: null,
        FolderTypeName: null,
        CreatedBy: null,
        CreatedOnDate: new Date('0001-01-01T00:00:00Z'),
        ModifiedBy: null,
        ModifiedDate: new Date('0001-01-01T00:00:00Z'),
        State: null,
        Hidden: false,
        FullPath: null,
        EntityFolderID: null,
        ShowInTree: false,
        SubMenuBehavior: 0 /* SubMenuBehavior.Default */,
        SubMenuGroupName: null,
        EntityDescription: null,
        NestingLevel: 0,
        HasSubFolders: false,
        CanBeExpanded: false,
        IsFavorite: false,
        FavoriteType: 3 /* FavoriteType.None */,
        OrderNum: 0,
        Color: null,
        IconUrl: null,
        Icon: null,
        AvailableForDisplayType: false,
        FolderCountResult: null,
        IsSimulatedRootFolder: false
    };
    return __assign(__assign({}, instance), data);
}
export function isFolderForTree(object) {
    return object.__type === "FolderForTree:#DecisionsFramework.ServiceLayer.Services.Folder";
}
